import { TreeListCellProps } from '@progress/kendo-react-treelist';
import { MouseEvent, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import { WorkAreaContext } from 'src/sections/work_area/WorkAreaContext';
import { stopPropagation } from 'src/utils';
import { useContextSelector } from 'use-context-selector';

const ActionCell = (props: TreeListCellProps) => {
  const { t } = useTranslation();
  const selectedCompanyId = useContextSelector(
    WorkAreaContext,
    (ctx) => ctx?.selectedCompanyId ?? null
  );
  const getImpersonate = useContextSelector(WorkAreaContext, (ctx) => ctx.getImpersonate);

  const dataItem = props.dataItem as { id?: number | string; realClientId?: number } | undefined;
  const clientId =
    dataItem?.realClientId != null
      ? Number(dataItem.realClientId)
      : dataItem?.id != null && typeof dataItem.id === 'number'
      ? dataItem.id
      : undefined;
  const companyId = selectedCompanyId ?? undefined;

  const { canImpersonate, isImpersonatedUser, handleImpersonate } = useMemo(
    () => getImpersonate(clientId, companyId),
    [getImpersonate, clientId, companyId]
  );

  const handleClick = useCallback(
    (e: MouseEvent) => {
      stopPropagation(e);
      handleImpersonate();
    },
    [handleImpersonate]
  );

  return (
    <td className={props.className} style={props.style}>
      <div className="flex items-stretch w-full h-full justify-center min-w-[100px] px-2">
        <Button
          type="button"
          color="info"
          disabled={!canImpersonate}
          onClick={handleClick}
          size="sm"
          className="w-fit text-[12px]"
        >
          {t(isImpersonatedUser ? 'impersonated' : 'impersonate')}
        </Button>
      </div>
    </td>
  );
};

export default ActionCell;
